import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";

import useTheme from "hooks/useTheme";

import TAccountsIcon from "theme/icons/TAccounts";
import ReorderIcon from "theme/icons/Reorder";
import SelectedDotIcon from "theme/icons/SelectedDot";

const AccountListItems = ({ account, index, activeAccount, setActiveAccount }) => {
	const { themeColor } = useTheme();

	const { setNodeRef, attributes, listeners, transition, transform, isDragging } = useSortable({
		id: index,
	});

	return (
		<div
			className={`flex w-full items-center justify-start space-x-2 my-1 ${isDragging ? "opacity-50" : "opacity-100"}`}
			onClick={() => setActiveAccount(account)}
			style={{
				transition,
				transform: CSS.Transform.toString(transform),
				marginBottom: 5,
				marginTop: 5,
				opacity: isDragging ? 0.5 : 1,
			}}
			ref={setNodeRef}
		>
			<ReorderIcon
				className={`w-5 hover:border-2 hover:rounded-lg focus:outline-none`}
				fill={themeColor?.hex}
				{...attributes}
				{...listeners}
			/>
			<div
				className={`flex w-full items-center justify-start space-x-4 py-4 px-3 rounded-xl cursor-pointer ${
					activeAccount?.["account-address"] === account?.["account-address"] && `${themeColor?.bg} bg-opacity-10`
				}`}
			>
				{account["profile-image"] ? (
					<img className={`w-6 object-cover object-center`} src={account["profile-image"]} alt="temp" />
				) : (
					<TAccountsIcon className="w-6" fill={themeColor?.hex} />
				)}

				<div className="w-full flex-col">
					<p className={`w-full text-sm font-bold ${themeColor?.text}`}>{account?.name}</p>
				</div>

				{activeAccount?.["account-address"] === account?.["account-address"] && (
					<SelectedDotIcon className="w-4" fill={themeColor?.hex} />
				)}
			</div>
		</div>
	);
};

export default AccountListItems;
